import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Header, Image, Segment } from 'semantic-ui-react';
import './walletStatement.css';
import { getCDNpath } from '../../app/common/util';
import { downloadStatement } from './statementActions';

const walletImg = getCDNpath('/static/images/statement-icon.png');

const mapState = state => ({
  auth: state.auth,
});

const actions = {
  downloadStatement
};
class WalletStatementContainer extends Component {
  static propTypes = {
    downloadStatement: PropTypes.func.isRequired
  };

  getDate = () => {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1; //January is 0!
    let yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    
    today = mm + dd + yyyy;

    return today;
  }

  handleClick = () => {
    const { auth, downloadStatement } = this.props;

    const fileName = `Wallet_Statement_${auth.profile && auth.profile.mobileNo}_${this.getDate()}`

    downloadStatement(auth.csrfRequestIdentifier, auth.migration && auth.migration.walletToken, fileName);
  };

  render() {
    return (
      <div id="feature-wallet-statement">
        <Header as="h1">Download 6 Months Statement</Header>

        <Segment className="no-content-segment" textAlign="center">
          <Image
            alt="No stored cards found!"
            centered
            src={walletImg}
            size="small"
          />
          <p style={{ margin: '20px auto' }}>
            Download the statement of all wallet transactions for last 6 months.
            Please note that these would include transactions done using wallet
            only.
          </p>
          <Button
            className="fcbtn fcprimary"
            type="submit"
            onClick={this.handleClick}
          >
            Download
          </Button>
        </Segment>
      </div>
    );
  }
}

export default connect(
  mapState,
  actions
)(WalletStatementContainer);
